module.exports = __webpack_public_path__ + "media/images/40yrs-bk-b3626acec3007d54d778928405423fde.jpg";